export default {
    'create-status': 'Create Status',
    headers: {
        name: 'Name',
        'invoice-type': 'Invoice Type',
        'is-final-status': 'is Final Status'
    },
    'create-delivery-status' : 'Create Delivery Status',
    'edit-delivery-status' : 'Edit Delivery Status',

    delete: {
        'delete-delivery-status': 'Delete Delivery Status',
        'delete-dialog-content': 'Are you sure you want to delete this delivery status ?',
    },

    inputs: {
        'delivery-name': 'Delivery Name',
        'invoice-type': 'Invoice Type',
        'final-status': 'Set as Final Status'
    },

    chips: {
        true: 'true',
        false: 'false'
    },

    buttons: {
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel'
    }
}